import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { Loader } from '@care/react-component-lib';
import { ExternalVendors } from '@/__generated__/globalTypes';
import { ViatorLogo } from './ViatorLogo';

export interface RedirectingProps {
  provider: ExternalVendors;
}

const VendorToLogoMap: Record<ExternalVendors, React.ReactNode> = {
  VIATOR: <ViatorLogo sx={{ width: 'auto', height: 'auto' }} />,
};
const VendorToStringMap: Record<ExternalVendors, string> = {
  VIATOR: 'Viator',
};

export const Redirecting: FC<RedirectingProps> = ({ provider }) => {
  return (
    <Stack sx={{ width: '100vw', height: '100vh' }} alignItems="center" justifyContent="center">
      <Stack gap={4} alignItems="center" maxWidth={500}>
        {VendorToLogoMap[provider]}
        <Stack alignItems="center" textAlign="center">
          <Typography
            typography={{ xs: 'h2', md: 'display3' }}
            sx={{
              m: 0,
              mb: 2,
              maxWidth: { xs: '95%', md: '100%' },
            }}>
            Redirecting you to {VendorToStringMap[provider]} for more details and booking...
          </Typography>
          <Typography
            typography={{ xs: 'body2', md: 'body1' }}
            sx={{
              maxWidth: { xs: '80%' },
              mb: { xs: 1, md: 4 },
            }}>
            You’ll be able to explore availability, pricing, and more on{' '}
            {`${VendorToStringMap[provider]}'s`} website.
          </Typography>
          <Loader />
        </Stack>
      </Stack>
    </Stack>
  );
};
